export enum SSOProvider {
  MICROSOFT = 'MICROSOFT',
  GOOGLE = 'GOOGLE'
}
